<template>
  <div id="app" :class="{hero: hero, 'no-hero': !hero, 'menu-open': menuOpen,
  'menu-animating': menuAnimating}">
    <side-menu @close="onMenuToggle(false)"/>
    <div id="menu-cover"></div>
    <div id="page" @transitionend="onMenuTransitionEnd">
      <fade-transition>
        <hero v-if="hero"/>
      </fade-transition>
      <shrink-transition>
        <div id="titlebar-placeholder" v-if="hero"></div>
      </shrink-transition>
      <!--    <div id="titlebar-strut" v-if="!hero"></div>-->
      <title-bar :always-stick="!hero" @toggle-menu="onMenuToggle"/>
      <fade-transition name="fade" @before-leave="beforeLeave" @enter="enter"
                       @after-enter="afterEnter" mode="out-in">
        <router-view/>
      </fade-transition>
      <page-footer/>
    </div>
  </div>
</template>

<script>
import Hero from '@/components/Hero.vue';
import SideMenu from '@/components/SideMenu.vue';
import TitleBar from '@/components/TitleBar.vue';
import PageFooter from '@/components/PageFooter.vue';

import FadeTransition from '@/components/transition/FadeTransition.vue';
import ShrinkTransition from '@/components/transition/ShrinkTransition.vue';

export default {
  components: {
    Hero,
    SideMenu,
    TitleBar,
    PageFooter,

    FadeTransition,
    ShrinkTransition,
  },

  data() {
    return {
      hero: this.$route.meta.hero || false,
      menuOpen: false,
      menuAnimating: false,
      contentHeight: 0,
    };
  },

  watch: {
    $route(to, from) {
      this.hero = to.meta.hero || false;
    },
  },

  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    enter(element) {
      const { height } = getComputedStyle(element);

      // eslint-disable-next-line no-param-reassign
      element.style.height = this.prevHeight;

      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        element.style.height = height;
      });
    },

    afterEnter(element) {
      // eslint-disable-next-line no-param-reassign
      element.style.height = 'auto';
    },

    onMenuToggle(target) {
      this.menuAnimating = true;
      if (typeof target !== 'undefined') {
        this.menuOpen = target;
      } else {
        this.menuOpen = !this.menuOpen;
      }
    },

    onMenuTransitionEnd(ev) {
      if (ev.target.id === 'page') {
        setTimeout(this.menuAnimationEnd, 400);
      }
    },

    menuAnimationEnd() {
      this.menuAnimating = false;
    },
  },
};
</script>

<style lang="scss">
  @import "scss/variables";

  #app {
    font-family: $font-stack;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    z-index: 1;
    position: relative;

    background-color: $body-bg;

    #page {
      position: relative;

      width: 100%;
      transition: width 450ms ease, transform 450ms ease;

      box-shadow: 3px 0 8px 0 rgba(51, 51, 51, .4);;
    }

    #titlebar-placeholder {
      background-color: transparent;
      width: 100%;

      animation-fill-mode: both;
    }

    #titlebar-placeholder {
      height: 2rem;

      @media only screen and (min-width: $breakpoint-md) {
        height: 3rem;
      }
    }

    #menu-cover {
      position: fixed;
      z-index: -1;
      width: 100%;
      height: 100%;

      background-color: $body-bg;
    }

    &.menu-open {
      #page, #menu-cover {
        transform: translateX(-350px);

        @media only screen and (min-width: 1201px) {
          transform: none;
          width: calc(100% - 350px);
        }
      }
    }

    &.menu-animating {
      #titlebar-placeholder {
        animation-delay: 450ms;
      }

      #title-bar {
        transition-delay: 450ms;

        .navbar-brand,
        .nav-item > .nav-link,
        .dropdown-nav-item > .dropdown-nav-toggle > a {
          transition-delay: 450ms;
        }
      }

      #hero {
        animation-delay: 450ms;
      }
    }
  }

  #app-content, #hero {
    /*transition: height 400ms ease, opacity 400ms ease;*/
    animation-fill-mode: both;
  }

  #hero {
    animation-delay: 200ms;
  }

  h1 {
    font-size: 1.75rem;
  }

  h2 {
    font-size: 1.6rem;
  }

  h3 {
    font-size: 1.45rem;
  }

  .page-section a,
  a.internal-link {
    cursor: pointer;
    user-select: none;

    transition: color 350ms ease;

    &:hover {
      text-decoration: underline;
    }

    &:active {
    }

    &:visited {
    }
  }
</style>
